import gsap, { Power2 } from 'gsap';

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { Ease } from '../_app/cuchillo/utils/Ease';

export class ScrollItem__Default extends VScroll_Item {
  titles = [];

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this._call = () => {
      this.loop();
    }

    this.defineAnimation();

    this.onShow = () => {
      this.showAnimation();
      gsap.ticker.add(this._call);
    };
    this.onHide = () => {
      gsap.ticker.remove(this._call);
    };
    this.onMove = () => { };
  }

  loop() { }

  defineAnimation() {
    // this.titles = Array.from(GetBy.class('__title', this.item));
    // if (this.titles.length > 0) gsap.set(this.titles, { y: '100%' });
  }

  showAnimation() {
    // if (this.titles.length === 0) return;

    // this.titles.map((item, i) => {
    //   gsap.to(item, {
    //     y: 0,
    //     duration: 1.2,
    //     delay: 0.1 * i,
    //     ease: Ease.EASE_CUCHILLO_IN_OUT,
    //   });
    // });
  }

  dispose() {
    gsap.ticker.remove(this._call);
    super.dispose();
  }
}

Scroll._registerClass('BlockDefault', ScrollItem__Default);